import Immutable from 'seamless-immutable';
import _ from 'lodash';

const DATA_REQUEST = 'DATA_REQUEST';
const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const INSERT_UPDATE_ITEMS = 'INSERT_UPDATE_ITEMS';
const INSERT_UPDATE_CHILD_ITEMS = 'INSERT_UPDATE_CHILD_ITEMS';
const DELETE_GROUP_ITEMS = 'DELETE_GROUP_ITEMS';
const DELETE_CHILD_ITEMS = 'DELETE_CHILD_ITEMS';
const INIT_STATE = 'INIT_STATE';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = reducerName => {
  function stateDefault() {
    return {
      name: 'listsCollection',
      requestsStates: {},
      itemsById: {},
      groupMapItemsIds: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(reducerName, DATA_REQUEST):
        return state;
      case createActionName(reducerName, REQUEST_IN_PROGRESS):
        return state.merge({
          requestsStates: {
            ...state.requestsStates,
            ...{
              [action.payload]: {
                requestInProcess: true,
                lastStatusCode: null,
                countQueries: state.requestsStates[action.payload]
                  ? state.requestsStates[action.payload].countQueries
                  : 0
              }
            }
          }
        });
      case createActionName(reducerName, REQUEST_FINISHED):
        return state.merge({
          requestsStates: {
            ...state.requestsStates,
            ...{
              [action.payload]: {
                requestInProcess: false,
                lastStatusCode: action.payload.code,
                countQueries:
                  state.requestsStates[action.payload].countQueries + 1
              }
            }
          }
        });
      case createActionName(reducerName, INSERT_UPDATE_ITEMS):
        return state.merge(
          {
            itemsById: action.payload.itemsById,
            groupMapItemsIds: action.payload.groupMapItemsIds
          },
          { deep: true }
        );
      case createActionName(reducerName, INSERT_UPDATE_CHILD_ITEMS): {
        const clone = Immutable.asMutable(state, { deep: true });
        clone.itemsById = {
          ...state.itemsById,
          ...action.payload.itemsById
        };
        Object.keys(action.payload.groupMapItemsIds).map(key => {
          action.payload.groupMapItemsIds[key].map(item => {
            if (key in clone.groupMapItemsIds) {
              // Если группа не новая то просто добавляем в нее в зависипости от place
              if (action.payload.place === 'up') {
                clone.groupMapItemsIds[key].unshift(item);
              } else {
                clone.groupMapItemsIds[key].push(item);
              }
            } else {
              // Если группы нет то создаем и добавляем
              clone.groupMapItemsIds[key] = [item];
            }
            return null;
          });
          return null;
        });
        return clone;
      }
      case createActionName(reducerName, DELETE_GROUP_ITEMS): {
        const clone = Immutable.asMutable(state, { deep: true });
        if (action.payload.groupMapKey in clone.groupMapItemsIds) {
          clone.groupMapItemsIds[action.payload.groupMapKey].map(
            childKey => delete clone.itemsById[childKey]
          );
          delete clone.groupMapItemsIds[action.payload.groupMapKey];
        }
        return clone;
      }
      case createActionName(reducerName, DELETE_CHILD_ITEMS): {
        const clone = Immutable.asMutable(state, { deep: true });
        action.payload.childIds.map(childKey => {
          if (action.payload.groupMapKey in clone.groupMapItemsIds) {
            const index = clone.groupMapItemsIds[
              action.payload.groupMapKey
            ].indexOf(childKey);
            if (index !== -1)
              clone.groupMapItemsIds[action.payload.groupMapKey].splice(
                index,
                1
              );
          }
          delete clone.itemsById[childKey];
          return null;
        });
        return clone;
      }
      case createActionName(reducerName, INIT_STATE):
        return Immutable({
          ...stateDefault(),
          ...{ mergeItemsMode: action.payload === true }
        });
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const dataRequest = (reducerName, payload) => ({
  type: createActionName(reducerName, DATA_REQUEST),
  payload
});
export const requestInProgress = (reducerName, payload) => ({
  type: createActionName(reducerName, REQUEST_IN_PROGRESS),
  payload
});
export const requestFinished = (reducerName, payload) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload
});
export const insertUpdateItems = (reducerName, payload) => ({
  type: createActionName(reducerName, INSERT_UPDATE_ITEMS),
  payload
});
export const insertUpdateChildItems = (reducerName, payload) => ({
  type: createActionName(reducerName, INSERT_UPDATE_CHILD_ITEMS),
  payload
});
export const deleteGroupItems = (reducerName, groupMapKey) => ({
  type: createActionName(reducerName, DELETE_GROUP_ITEMS),
  payload: { groupMapKey }
});
export const deleteChildItems = (reducerName, groupMapKey, childIds) => ({
  type: createActionName(reducerName, DELETE_CHILD_ITEMS),
  payload: { groupMapKey, childIds }
});
export const initState = (reducerName, payload) => ({
  type: createActionName(reducerName, INIT_STATE),
  payload
});

// SELECTORS
export const selectIdsByGroupId = (state, reducerName, id) => {
  const ids = getState(state, reducerName).groupMapItemsIds[id];
  if (ids) {
    return ids;
  }
  return [];
};

export const selectItemById = (state, reducerName, id) => {
  const ids = getState(state, reducerName).itemsById[id];
  if (ids) {
    return ids;
  }
  return null;
};

export const selectItemsByGroupId = (state, reducerName, id) => {
  const ids = _.get(getState(state, reducerName), ['groupMapItemsIds', [id]]);
  if (!_.isEmpty(ids)) {
    return _.pick(getState(state, reducerName).itemsById, ids);
  }
  return null;
};

export const selectLastItemByGroupId = (state, reducerName, id) => {
  const ids = getState(state, reducerName).groupMapItemsIds[id];
  if (!_.isEmpty(ids)) {
    return getState(state, reducerName).itemsById[ids[ids.length - 1]];
  }
  return null;
};

export const selectRequestsStateByGroupId = (state, reducerName, id) => {
  const requestState = getState(state, reducerName).requestsStates[id];
  if (requestState) {
    return requestState;
  }
  return {
    requestInProcess: false,
    lastStatusCode: null,
    countQueries: 0
  };
};



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/listsCollection/reducer.js